export default __webpack_public_path__ + "static/media/workspaces-24.b93b5f8e.svg";